<div class="container">
  <app-learn-more-menu-button *ngIf="showLearnMore"></app-learn-more-menu-button>
  <ng-container *ngIf="!mobileView">
    <button
      class="ts-button base text disable-focus"
      [matMenuTriggerFor]="menu"
    >
      Contact us
    </button>
    <a
      class="ts-button base text disable-focus"
      routerLink="/login"
      >Log in
    </a>
  </ng-container>
  <button
    mat-icon-button
    [matMenuTriggerFor]="menu"
    disableRipple
    *ngIf="mobileView && showMobileMenu"
  >
    <mat-icon
      class="menu-icon"
      svgIcon="menu"
    ></mat-icon>
  </button>
  <mat-menu
    #menu="matMenu"
    class="public-header-help-menu"
  >
    <ng-container *ngIf="mobileView">
      <a
        mat-menu-item
        class="menu-item"
        routerLink="/login"
      >
        Log in
      </a>
      <mat-divider></mat-divider>
    </ng-container>
    <a
      mat-menu-item
      class="email-us menu-item"
      href="mailto:{{ HELP_EMAIL }}"
      rel="noopener nofollow noreferrer"
    >
      {{ HELP_EMAIL }}
    </a>
  </mat-menu>
</div>
